import { ErrorBox, Loading } from "@gearbox-protocol/deploy-tools-ui";
import { chains, getNetworkType } from "@gearbox-protocol/sdk/onchain";
import type { FC } from "react";
import { useMemo } from "react";

import { useUnpausedForkStatus } from "../context";
import BalancesList from "./BalancesList";
import { useMyAssets } from "./MyAssetsProvider";
import type { Balance } from "./useTokenBalances";

const MyAssetsCard: FC = () => {
  const { tokens, native } = useMyAssets();
  const { originChainId } = useUnpausedForkStatus();

  const nativeSymbol = useMemo(
    () => chains[getNetworkType(originChainId)].nativeCurrency.symbol,
    [originChainId],
  );

  const balances = useMemo<Balance[]>(() => {
    const nativeBalance = native.balance || (native.loading ? "…" : "0");
    return [[nativeSymbol, nativeBalance], ...(tokens.value ?? [])];
  }, [nativeSymbol, native.balance, native.loading, tokens.value]);

  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border p-4">
      <h3>Your assets</h3>

      {!!tokens.error && <ErrorBox error={tokens.error} />}

      <BalancesList tokens={balances} />

      {!!tokens.loading && <Loading />}
    </div>
  );
};

export default MyAssetsCard;
